var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.filter.inputs.value.options, function(option) {
        return [
          _c("div", { key: option.value, staticClass: "form-group" }, [
            _c(
              "label",
              {
                staticClass: "form-label label-auto",
                attrs: { for: "opt-" + option.value }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value,
                      expression: "value"
                    }
                  ],
                  attrs: {
                    type: "radio",
                    name: "options[]",
                    id: "opt-" + option.value
                  },
                  domProps: {
                    value: option.value,
                    checked: _vm._q(_vm.value, option.value)
                  },
                  on: {
                    change: function($event) {
                      _vm.value = option.value
                    }
                  }
                }),
                _vm._v("\n\t\t\t\t" + _vm._s(option.label) + "\n\t\t\t")
              ]
            )
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }